// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
}

.tip-component {
  color: white;
  margin-bottom: 12px;
  background: #fff !important;
  border-radius: var(--radius-default);
}

.title-row {
  padding: 0;
  margin-bottom: 12px;
  text-transform: none;
}

.title {
  padding: 0;
  display: flex;
  align-items: flex-end;
  font-family: AppFontTitle;
  font-size: 14px;
  font-weight: 700;
  line-height: 21.6px;
  letter-spacing: 0.01em;
  text-align: left;
  color: var(--ion-color-primary);
  text-transform: capitalize;
}

.custom {
  display: flex;
  justify-content: flex-end;
  align-self: center;
  padding: 0px;
}
.custom .custom-block {
  border-radius: var(--radius-default);
  width: -moz-fit-content;
  width: fit-content;
  height: 29px;
  padding: 0 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: 700;
  color: var(--ion-color-primary);
}
.custom ion-icon {
  zoom: 0.8;
  margin-left: 5px;
}
.custom p {
  margin: 0px;
  font-family: AppFontSemiBold, sans-serif;
  font-size: 12px;
  line-height: 16px;
  padding: 0px;
  display: flex;
  justify-content: flex-end;
  align-self: center;
  padding-right: 5px;
  color: #1e1e1c;
}

.tip {
  box-sizing: border-box;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: var(--radius-default);
  border: 1px solid var(--ion-color-secondary);
  background: #fff;
  cursor: pointer;
}
.tip > * {
  margin: 0;
  padding: 0;
}
.tip h4 {
  font-family: AppFont;
  font-size: 14px;
  line-height: 18.82px;
  text-align: center;
  color: #1e1e1c;
}
.tip .sum {
  font-family: AppFont;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: var(--color-black);
  white-space: pre-line;
}
.tip.selected {
  color: #fff;
  background: var(--ion-color-secondary) !important;
  border-color: var(--ion-color-secondary);
}
.tip.selected p,
.tip.selected h4 {
  color: #fff;
}
.tip.selected-custom {
  min-height: 48px;
  color: #fff;
  background: var(--ion-color-secondary) !important;
  border-color: var(--ion-color-secondary);
}
.tip.selected-custom p {
  color: #fff;
}

.custom-tip-row {
  justify-content: space-between;
}
.custom-tip-row ion-icon {
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 50%;
  height: 35px;
  width: 35px;
  transform: translateY(-50%);
}
.custom-tip-row ion-item {
  color: white;
  font-family: "POPINSBOLD", sans-serif;
  --padding-start: 18px !important;
}

.tip-row {
  padding: 0px;
  gap: 8px;
}

.tip-img {
  width: 18px;
  height: 18px;
  margin-bottom: 5px !important;
}

.selected {
  color: white;
  background: #feaf3c !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/tip/tip.component.scss"],"names":[],"mappings":"AAEA;EACC,cAAA;EACA,WAAA;AADD;;AAIA;EACC,YAAA;EACA,mBAAA;EACA,2BAAA;EACA,oCAAA;AADD;;AAGA;EACC,UAAA;EACA,mBAAA;EACA,oBAAA;AAAD;;AAEA;EACC,UAAA;EACA,aAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EAEA,+BAAA;EACA,0BAAA;AAAD;;AAGA;EACC,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AAAD;AACC;EACC,oCAAA;EACA,uBAAA;EAAA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,eAAA;EACA,gBAAA;EACA,+BAAA;AAAF;AAIC;EACC,SAAA;EACA,gBAAA;AAFF;AAIC;EACC,WAAA;EACA,wCAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AAFF;;AAMA;EAMC,sBAAA;EACA,kBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EAEA,oCAAA;EACA,4CAAA;EACA,gBAAA;EAUA,eAAA;AAnBD;AAqBC;EACC,SAAA;EACA,UAAA;AAnBF;AAsBC;EACC,oBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EAEA,cAAA;AArBF;AAwBC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;AAtBF;AAyBC;EACC,WAAA;EACA,iDAAA;EACA,wCAAA;AAvBF;AAyBE;;EAEC,WAAA;AAvBH;AA2BC;EACC,gBAAA;EACA,WAAA;EACA,iDAAA;EACA,wCAAA;AAzBF;AA0BE;EACC,WAAA;AAxBH;;AA6BA;EACC,8BAAA;AA1BD;AA4BC;EACC,eAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,2BAAA;AA1BF;AA4BC;EACC,YAAA;EACA,qCAAA;EACA,gCAAA;AA1BF;;AA6BA;EACC,YAAA;EACA,QAAA;AA1BD;;AA4BA;EACC,WAAA;EACA,YAAA;EACA,6BAAA;AAzBD;;AA2BA;EACC,YAAA;EACA,8BAAA;AAxBD","sourcesContent":["@use '../../../theme/mixins' as *;\n\n:host {\n\tdisplay: block;\n\twidth: 100%;\n}\n\n.tip-component {\n\tcolor: white;\n\tmargin-bottom: 12px;\n\tbackground: #fff !important ;\n\tborder-radius: var(--radius-default);\n}\n.title-row {\n\tpadding: 0;\n\tmargin-bottom: 12px;\n\ttext-transform: none;\n}\n.title {\n\tpadding: 0;\n\tdisplay: flex;\n\talign-items: flex-end;\n\tfont-family: AppFontTitle;\n\tfont-size: 14px;\n\tfont-weight: 700;\n\tline-height: 21.6px;\n\tletter-spacing: 0.01em;\n\ttext-align: left;\n\n\tcolor: var(--ion-color-primary);\n\ttext-transform: capitalize;\n}\n\n.custom {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\talign-self: center;\n\tpadding: 0px;\n\t.custom-block {\n\t\tborder-radius: var(--radius-default);\n\t\twidth: fit-content;\n\t\theight: 29px;\n\t\tpadding: 0 8px;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\tfont-size: 12px;\n\t\tfont-weight: 700;\n\t\tcolor: var(--ion-color-primary);\n\t\t// text-transform: uppercase;\n\t}\n\n\tion-icon {\n\t\tzoom: 0.8;\n\t\tmargin-left: 5px;\n\t}\n\tp {\n\t\tmargin: 0px;\n\t\tfont-family: AppFontSemiBold, sans-serif;\n\t\tfont-size: 12px;\n\t\tline-height: 16px;\n\t\tpadding: 0px;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-end;\n\t\talign-self: center;\n\t\tpadding-right: 5px;\n\t\tcolor: #1e1e1c;\n\t}\n}\n\n.tip {\n\t// margin-right: 8px;\n\t// margin-left: 8px;\n\t// padding: 15px 22px 16px;\n\t// height: 48px;\n\n\tbox-sizing: border-box;\n\ttext-align: center;\n\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex-direction: column;\n\n\tborder-radius: var(--radius-default);\n\tborder: 1px solid var(--ion-color-secondary);\n\tbackground: #fff;\n\n\t// &:first-of-type {\n\t// \tmargin-left: 0;\n\t// }\n\n\t// &:last-of-type {\n\t// \tmargin-right: 0;\n\t// }\n\n\tcursor: pointer;\n\n\t> * {\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t}\n\n\th4 {\n\t\tfont-family: AppFont;\n\t\tfont-size: 14px;\n\t\tline-height: 18.82px;\n\t\ttext-align: center;\n\n\t\tcolor: #1e1e1c;\n\t}\n\n\t.sum {\n\t\tfont-family: AppFont;\n\t\tfont-size: 12px;\n\t\tline-height: 18px;\n\t\ttext-align: center;\n\t\tcolor: var(--color-black);\n\t\twhite-space: pre-line;\n\t}\n\n\t&.selected {\n\t\tcolor: #fff;\n\t\tbackground: var(--ion-color-secondary) !important;\n\t\tborder-color: var(--ion-color-secondary);\n\n\t\tp,\n\t\th4 {\n\t\t\tcolor: #fff;\n\t\t}\n\t}\n\n\t&.selected-custom {\n\t\tmin-height: 48px;\n\t\tcolor: #fff;\n\t\tbackground: var(--ion-color-secondary) !important;\n\t\tborder-color: var(--ion-color-secondary);\n\t\tp {\n\t\t\tcolor: #fff;\n\t\t}\n\t}\n}\n\n.custom-tip-row {\n\tjustify-content: space-between;\n\n\tion-icon {\n\t\tcursor: pointer;\n\t\tposition: absolute;\n\t\tright: 10px;\n\t\ttop: 50%;\n\t\theight: 35px;\n\t\twidth: 35px;\n\t\ttransform: translateY(-50%);\n\t}\n\tion-item {\n\t\tcolor: white;\n\t\tfont-family: 'POPINSBOLD', sans-serif;\n\t\t--padding-start: 18px !important;\n\t}\n}\n.tip-row {\n\tpadding: 0px;\n\tgap: 8px;\n}\n.tip-img {\n\twidth: 18px;\n\theight: 18px;\n\tmargin-bottom: 5px !important;\n}\n.selected {\n\tcolor: white;\n\tbackground: #feaf3c !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
